import axios from 'axios';
import { takeLatest, put, call } from 'redux-saga/effects';

import * as types from '../ActionTypes/MembershipPlansActionTypes';
import { MembershipPlansActionCreators } from '../ActionCreators/MembershipPlansActionCreators';
import { membershipPlans } from '../../BusinessLogic/Network/API/MembershipPlansApi';

export class MembershipPlansSaga {
    static *getMembershipPlans() {
        try {
            const membership = membershipPlans.create();

            const { data: response } = yield call(axios, membership.getMemberhsipPlans());
            yield put(MembershipPlansActionCreators.getMembershipPlansSuccess(response.data));
        } catch (error) {
            yield put(MembershipPlansActionCreators.getMembershipPlansFailed(error));
        }
    }

    static *addMembershipPlan({ meta: { planData } }) {
        try {
            const membership = membershipPlans.create();

            const { data: response } = yield call(axios, membership.addMembershipPlan(planData));
            yield put(MembershipPlansActionCreators.addMembershipPlanSuccess(response.data));
        } catch (error) {
            yield put(MembershipPlansActionCreators.addMembershipPlanFailed(error));
        }
    }

    static *updateMembershipPlan({ meta: { id, planData } }) {
        try {
            const membership = membershipPlans.create();

            const { data: response } = yield call(axios, membership.updateMembershipPlan(id, planData));
            yield put(MembershipPlansActionCreators.updateMembershipPlanSuccess(response.data));
        } catch (error) {
            yield put(MembershipPlansActionCreators.updateMembershipPlanFailed(error));
        }
    }

    static *deleteMembershipPlan({ meta: { id } }) {
        try {
            const membership = membershipPlans.create();

            yield call(axios, membership.deleteMembershipPlan(id));
            yield put(MembershipPlansActionCreators.deleteMembershipPlanSuccess(id));
        } catch (error) {
            yield put(MembershipPlansActionCreators.deleteMembershipPlanFailed(error));
        }
    }
}

export function* saga() {
    yield takeLatest(types.GET_MEMBERSHIP_PLANS_REQUEST, MembershipPlansSaga.getMembershipPlans);
    yield takeLatest(types.ADD_MEMBERSHIP_PLAN_REQUEST, MembershipPlansSaga.addMembershipPlan);
    yield takeLatest(types.UPDATE_MEMBERSHIP_PLAN_REQUEST, MembershipPlansSaga.updateMembershipPlan);
    yield takeLatest(types.DELETE_MEMBERSHIP_PLAN_REQUEST, MembershipPlansSaga.deleteMembershipPlan);
}



// WEBPACK FOOTER //
// ./src/Store/Saga/MembershipPlansSaga.js